import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import NavSection from "./NavSection";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { allCompanyDetails } from "../../../store/allCompanyDetailsSlice";

const APP_BAR_MOBILE = 80;
const APP_BAR_DESKTOP = 60;

const StyledRoot = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const Main = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE,
  paddingLeft: 10,
  // paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 14,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
}));

export default function DashboardLayout() {
  const theme = useTheme();
  const isBelow768 = useMediaQuery(theme.breakpoints.down("sm"));
  
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(allCompanyDetails());
  }, []);

  return (
    <StyledRoot>
      <NavSection />

      <Main>
        <Outlet />
        <Box
          sx={{
            padding: "3px 0",
            position:'fixed',
            right:5,
            bottom:0,
            display: "flex",
            justifyContent: isBelow768 ? "center" : "flex-end",
            alignItems: "center",
            width: "100%",
            backgroundColor:'white',
          }}
        >
            <a
              style={{ textDecoration: "none" }}
              href="https://meon.co.in/"
              rel="noreferrer"
              target="_blank"
            >
              {" "}
              <img src="/meon.png" width={95} alt="im" />
            </a>{" "}
        
        </Box>
      </Main>
    </StyledRoot>
  );
}
